import { render, staticRenderFns } from "./RateSheetDefinitionVersionEditor.vue?vue&type=template&id=2515bf00&"
import script from "./RateSheetDefinitionVersionEditor.vue?vue&type=script&lang=js&"
export * from "./RateSheetDefinitionVersionEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports